import { render, staticRenderFns } from "./ReActivatePositionPopup.vue?vue&type=template&id=7fd3bec8"
import script from "./ReActivatePositionPopup.vue?vue&type=script&lang=js"
export * from "./ReActivatePositionPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports